<!-- Title from app-page-wrapper, like the other pages (it was its own smaller, uncoloured span). -->
<app-page-wrapper [title]="'settings' | i18n">
  <div class="tw-flex tw-h-auto tw-w-full tw-justify-center md:tw-mb-[88px]">
    <div
      class="tw-flex tw-h-auto tw-w-full tw-flex-col tw-gap-6 tw-rounded-lg tw-max-w-full tw-min-w-0 md:tw-h-full"
    >
      <div class="tw-flex-col tw-flex tw-gap-6 tw-min-w-0">
        @if (showUpgradePromo()) {
          <div
            data-testid="bundles-promo-banner"
            class="tw-rounded-2xl tw-p-5 tw-flex tw-flex-col tw-gap-5 tw-shadow-lg tw-text-white tw-bg-gradient-to-r tw-from-[#003F3F] tw-to-[#3DA0A0]"
          >
            <div
              class="tw-w-fit tw-flex tw-items-center tw-gap-1 tw-px-3 tw-py-1 tw-rounded-full tw-border-2 tw-border-dt-today-300"
            >
              <icon [name]="'stars'" [size]="4" [currentColor]="'teal-500'"></icon>
              <span
                class="tw-text-[14px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-teal-500"
              >
                {{ "glossBundles" | i18n }}
              </span>
            </div>

            <div>
              <div class="tw-text-[16px] tw-font-semibold tw-leading-tight">
                {{ "unlockAutoBankSync" | i18n }}
              </div>
              <div class="tw-text-[14px] tw-text-dt-slate-8">
                {{ "startWith14DayFreeTrial" | i18n }}
              </div>
            </div>

            <button
              type="button"
              class="tw-mt-2 tw-w-fit tw-px-8 tw-py-3 tw-rounded-2xl tw-text-white tw-font-bold tw-text-[16px] tw-transition-all hover:tw-brightness-110 active:tw-scale-95 tw-bg-gradient-to-r tw-from-[#008081] tw-to-[#00B8B9]"
              [routerLink]="getSettingsRoute(MainSettingsRoute.Plans)"
            >
              {{ "explorePlans" | i18n }}
            </button>
          </div>
        }

        <div class="tw-flex tw-gap-4 tw-items-start tw-w-full md:tw-flex-col">
          <div class="tw-flex tw-w-1/2 tw-min-w-0 md:tw-w-full">
            <div
              class="tw-rounded-2xl tw-p-2 tw-shadow-card-elevated tw-bg-dt-surface-card tw-w-full tw-min-w-0"
            >
              <div
                class="tw-h-auto tw-w-full tw-items-center tw-rounded-t-lg tw-bg-color-surface-card tw-px-4 tw-pb-4 tw-pt-2 md:tw-p-4"
              >
                <span
                  class="tw-mb-0 tw-text-lg tw-font-medium tw-text-color-text-secondary tw-uppercase tw-tracking-wider md:tw-text-lg"
                >
                  {{ "personal" | i18n }}
                </span>
              </div>

              <div class="tw-flex tw-h-auto tw-flex-col tw-gap-1 tw-min-w-0">
                <nav-panel
                  [ngClass]="'border-bottom-gray'"
                  [title]="'profile' | i18n"
                  [iconName]="'profile-icon'"
                  [routerLink]="getSettingsRoute(MainSettingsRoute.Profile)"
                >
                  <div class="tw-text-[13px] tw-text-dt-slate-11">
                    {{ "name" | i18n }}, {{ "email" | i18n }}
                  </div>
                </nav-panel>

                <nav-panel
                  [title]="'security' | i18n"
                  [iconName]="'security'"
                  [routerLink]="getSettingsRoute(MainSettingsRoute.Security)"
                >
                  <div class="tw-text-[13px] tw-text-dt-slate-11 tw-break-words">
                    {{ "changePassword" | i18n }}, {{ "masterPassHintLabel" | i18n }},
                    {{ "loginDevices" | i18n }}
                  </div>
                </nav-panel>
              </div>
            </div>
          </div>

          <div class="tw-flex tw-w-1/2 tw-min-w-0 md:tw-w-full">
            <div
              class="tw-rounded-2xl tw-p-2 tw-shadow-card-elevated tw-bg-dt-surface-card tw-w-full tw-min-w-0"
            >
              <div
                class="tw-h-auto tw-w-full tw-items-center tw-rounded-t-lg tw-bg-color-surface-card tw-px-4 tw-pb-4 tw-pt-2 md:tw-p-4"
              >
                <span
                  class="tw-mb-0 tw-text-lg tw-font-medium tw-text-color-text-secondary tw-uppercase tw-tracking-wider md:tw-text-lg"
                >
                  {{ "preferences" | i18n }}
                </span>
              </div>

              <div class="tw-flex tw-h-auto tw-flex-col tw-gap-1 tw-min-w-0">
                <nav-panel
                  [ngClass]="'border-bottom-gray'"
                  [title]="'preferences' | i18n"
                  [routerLink]="getSettingsRoute(MainSettingsRoute.Preferences)"
                  [iconName]="'preferences'"
                >
                  <div
                    class="tw-text-[13px] tw-text-dt-slate-11 tw-break-words md:tw-whitespace-normal"
                  >
                    {{ "userLocation" | i18n }}, {{ "coreCurrency" | i18n }},
                    {{ "dateFormats" | i18n }}
                  </div>
                </nav-panel>

                <ng-container *appRoleScope="'BETA_ACCESS'">
                  <nav-panel
                    [title]="'dailyAutoFetch' | i18n"
                    [iconName]="'daily-auto-fetch'"
                    [showToggle]="true"
                    [toggleEnabled]="dailyAutoFetchEnabled"
                    (toggleChange)="onDailyAutoFetchToggle($event)"
                  >
                    <div
                      badge-content
                      class="tw-px-2 tw-py-0.5 tw-rounded-full tw-text-primary tw-border tw-border-primary tw-text-[11px] tw-font-medium tw-flex-shrink-0"
                    >
                      {{ "comingSoon" | i18n }}
                    </div>
                    <div
                      class="tw-text-[13px] tw-text-dt-slate-11 tw-break-words md:tw-whitespace-normal"
                    >
                      {{ "fetchTransactionsAutomatically" | i18n }}
                    </div>
                  </nav-panel>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <div class="tw-grid tw-grid-cols-5 tw-gap-4 tw-w-full tw-min-w-0">
          <!-- Not a link itself: it holds the Bundles/Billing links and the Upgrade button, and a link
             wrapping them flattened them for screen readers and made Billing land on Plans. -->
          <div
            data-testid="access-card"
            class="md:tw-col-span-5 tw-col-span-4 tw-flex tw-flex-col tw-gap-1 tw-bg-dt-surface-card tw-rounded-2xl tw-p-2 tw-shadow-card-elevated"
          >
            <div
              class="tw-flex tw-w-full tw-items-center tw-justify-between tw-rounded-t-lg tw-bg-color-surface-card tw-px-4 tw-pb-4 tw-pt-2 md:tw-p-4"
            >
              <div class="tw-flex tw-flex-col">
                <span
                  class="tw-mb-0 tw-text-lg tw-font-medium tw-text-color-text-secondary tw-uppercase tw-tracking-wider md:tw-text-lg"
                >
                  {{ "access" | i18n }}
                </span>
              </div>
            </div>

            <div class="tw-flex tw-flex-col tw-gap-1">
              <nav-panel
                [title]="'bundles' | i18n"
                [iconName]="'bundles'"
                [routerLink]="getSettingsRoute(MainSettingsRoute.Plans)"
                [ngClass]="'border-bottom-gray'"
              >
                <div
                  badge-content
                  class="tw-w-fit tw-flex tw-items-center tw-gap-1 tw-px-3 tw-py-1 tw-rounded-full tw-border tw-border-dt-today-300 tw-flex-shrink-0"
                >
                  <icon [name]="'stars'" [size]="4" [currentColor]="'teal-950'"></icon>
                  <span
                    class="tw-text-[13px] tw-font-semibold tw-items-center tw-tracking-wider tw-text-teal-950"
                  >
                    {{ "aussieBankBundle" | i18n }}
                  </span>
                </div>
              </nav-panel>

              @if (isSubscriptionPageEnabled()) {
                <nav-panel
                  data-testid="access-billing-link"
                  [title]="'billing' | i18n"
                  [iconName]="'billing'"
                  [routerLink]="getSettingsRoute(MainSettingsRoute.Subscription)"
                >
                </nav-panel>
              }
            </div>
            @if (showUpgradePromo()) {
              <button
                type="button"
                data-testid="access-upgrade-button"
                (click)="onUpgradeClick()"
                class="tw-bg-dt-surface-elevated tw-px-4 tw-h-10 tw-border-2 tw-border-b-4 tw-border-primary tw-rounded-full"
              >
                {{ "upgrade" | i18n }}
              </button>
            }
          </div>

          <div
            class="md:tw-col-span-2 tw-col-span-1 tw-flex tw-flex-col tw-w-full tw-rounded-2xl tw-p-2 tw-shadow-card-elevated tw-bg-dt-surface-card tw-min-w-0"
          >
            <div
              class="tw-flex tw-w-full tw-items-center tw-justify-between tw-rounded-t-lg tw-bg-color-surface-card tw-px-4 tw-pb-4 tw-pt-2 md:tw-p-4"
            >
              <span
                class="tw-mb-0 tw-text-lg tw-font-medium tw-text-color-text-secondary md:tw-text-lg"
              >
                {{ "storage" | i18n }}
              </span>
              <div class="tw-relative tw-ml-0">
                <icon [name]="'right-arrow'" [size]="7" [currentColor]="'neutral-800'"></icon>
              </div>
            </div>

            <div
              class="tw-flex tw-h-auto tw-flex-col tw-gap-1 tw-min-w-0 tw-items-center tw-justify-center"
            >
              <nav-panel
                [title]="'storage' | i18n"
                [storageLayout]="true"
                [routerLink]="getSettingsRoute(MainSettingsRoute.Storage)"
                class="tw-w-full"
              >
                <div
                  storage-content
                  class="tw-flex tw-justify-center tw-items-center tw-w-full tw-py-2"
                >
                  <app-meter
                    variant="circle"
                    [value]="storageUsage().usedRatio"
                    size="tw-w-36 tw-h-36"
                    [strokeWidth]="5"
                  ></app-meter>
                </div>
              </nav-panel>
            </div>
          </div>

          <div class="md:tw-col-span-3 tw-col-span-5 tw-flex tw-w-full tw-min-w-0">
            <div
              class="tw-rounded-2xl tw-p-2 tw-shadow-card-elevated tw-bg-dt-surface-card tw-w-full tw-min-w-0"
            >
              <div
                class="tw-flex tw-w-full tw-items-center tw-justify-between tw-rounded-t-lg tw-bg-color-surface-card tw-px-4 tw-pb-4 tw-pt-2 md:tw-p-4"
              >
                <span
                  class="tw-mb-0 tw-text-lg tw-font-medium tw-text-color-text-secondary tw-uppercase tw-tracking-wider md:tw-text-lg"
                >
                  {{ "advanced" | i18n }}
                </span>
                <!-- Mobile only: arrow sits on the header row; nav-panel hides its own arrow here -->
                <a
                  class="tw-hidden tw-flex-shrink-0 md:tw-block"
                  aria-hidden="true"
                  tabindex="-1"
                  [routerLink]="getSettingsRoute(MainSettingsRoute.AdvancedFeatures)"
                >
                  <icon [name]="'right-arrow'" [size]="7" [currentColor]="'neutral-800'"></icon>
                </a>
              </div>

              <div class="tw-flex tw-h-auto tw-flex-col tw-gap-1 tw-min-w-0">
                <nav-panel
                  [title]="'advancedFeatures' | i18n"
                  [iconName]="'advance-feature'"
                  [stackLayout]="true"
                  [routerLink]="getSettingsRoute(MainSettingsRoute.AdvancedFeatures)"
                >
                  <div
                    advanced-content
                    class="tw-flex tw-flex-col tw-gap-1 tw-w-full tw-min-w-0 tw-text-[13px] tw-text-dt-slate-11"
                  >
                    <div class="tw-break-words md:tw-whitespace-normal">
                      {{ "deauthorizeSessions" | i18n }}, {{ "deleteAccount" | i18n }}
                    </div>

                    <ng-container *ngIf="basiqIntegrationEnabled()">
                      <div
                        class="tw-break-words md:tw-whitespace-normal tw-mt-1"
                        *appRoleScope="'BETA_ACCESS'"
                      >
                        {{ "removeBasiqConsent" | i18n }}, {{ "removeFiskilConsent" | i18n }},
                        {{ "purgeVault" | i18n }}
                      </div>
                    </ng-container>
                  </div>
                </nav-panel>
              </div>
            </div>
          </div>
        </div>

        <!-- focus-card: keyboard focus on each card's button outlines the whole card (base.scss). -->
        <div class="tw-flex tw-gap-3 xs:tw-justify-around md:tw-flex-col md:tw-gap-4 tw-w-full">
          <div
            class="focus-card tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-color-text-default tw-rounded-2xl tw-p-4 tw-shadow-card-elevated tw-bg-dt-surface-card tw-flex-1 tw-h-[70px] md:tw-w-full md:tw-items-center"
          >
            <button
              type="button"
              class="focus-card-trigger tw-flex tw-items-center tw-justify-center tw-gap-2"
              (click)="lock()"
            >
              <span class="tw-text-[16px] tw-text-color-text-default">{{ "lockNow" | i18n }}</span>
              <icon [name]="'lock'" [size]="6" [currentColor]="'color-icon-default'"></icon>
            </button>
            <div class="tw-break-words tw-mt-1 tw-text-center tw-text-[13px] tw-text-dt-slate-11">
              {{ "secureYourAccount" | i18n }}
            </div>
          </div>

          <div
            class="focus-card tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-color-text-default tw-rounded-2xl tw-p-4 tw-shadow-card-elevated tw-bg-dt-surface-card tw-flex-1 tw-h-[70px] md:tw-w-full md:tw-items-center"
          >
            <button
              type="button"
              class="focus-card-trigger tw-flex tw-items-center tw-justify-center tw-gap-2"
              (click)="logOut()"
            >
              <span class="tw-text-[16px] tw-text-color-text-default">{{ "logOut" | i18n }}</span>
              <icon [name]="'logOut'" [size]="6" [currentColor]="'color-icon-default'"></icon>
            </button>
            <div class="tw-break-words tw-text-center tw-text-[13px] tw-text-dt-slate-11">
              {{ "signOutFromThisDevice" | i18n }}
            </div>
          </div>

          @if (isDevMode) {
            <div
              *appRoleScope="'BETA_ACCESS'"
              class="focus-card tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-color-text-default tw-rounded-2xl tw-p-4 tw-shadow-card-elevated tw-bg-dt-surface-card tw-flex-1 tw-h-[70px] md:tw-w-full md:tw-items-center"
            >
              <button
                type="button"
                class="focus-card-trigger tw-flex tw-items-center tw-justify-center tw-gap-2"
                (click)="exportVault()"
              >
                <span class="tw-text-[16px] tw-text-danger">{{ "exportVault" | i18n }}</span>
                <icon [name]="'logOut'" [size]="6" [currentColor]="'dt-neutral-700'"></icon>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</app-page-wrapper>
